import React, { useEffect, useState } from 'react';
import AddEditInterfaceModal from '../../components/Modals/AddEditInterfaceModal';
import LabelValueDisplay from '../../components/LabelValue/LabelValueDisplay';

interface Props {
  open: boolean;
  mode?: 'add' | 'edit';
  initialName?: string;
  initialHubIps?: string;
  initialPassword?: string;
  onClose: () => void;
  onSave: (name: string, hubIps: string, password: string) => void;
  saving?: boolean;
}

const AddPrivateHubModal: React.FC<Props> = ({
  open,
  mode = 'add',
  initialName = '',
  initialHubIps = '',
  initialPassword = '',
  onClose,
  onSave,
  saving = false,
}) => {
  const [name, setName] = useState('');
  const [hubIps, setHubIps] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open) {
      setName(initialName);
      setHubIps(initialHubIps);
      setPassword(initialPassword);
    }
  }, [open, initialName, initialHubIps, initialPassword]);

  const isEdit = mode === 'edit';

  return (
    <AddEditInterfaceModal
      open={open}
      onClose={onClose}
      onSave={() => onSave(name.trim(), hubIps.trim(), password)}
      title={isEdit ? 'Edit Private Hub' : 'Add Private Hub'}
      saveText={isEdit ? 'Save' : 'Create'}
      disableSave={!name.trim() || !hubIps.trim() || saving}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Hub Name"
                  isInput
                  value={name}
                  onChange={(e: any) => setName(e.target.value)}
                  placeholder="Enter a name for this hub"
                  disabled={saving}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Hub IP(s) / Domain(s)"
                  isInput
                  value={hubIps}
                  onChange={(e: any) => setHubIps(e.target.value)}
                  placeholder="e.g. 10.0.0.1:8080, 10.0.0.2:8080"
                  disabled={saving}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Password (optional)"
                  isInput
                  isPassword
                  passwordClass
                  value={password}
                  onChange={(e: any) => setPassword(e.target.value)}
                  placeholder="Enter a password"
                  disabled={saving}
                />
              ),
              gridSize: 12,
            },
          ],
        },
      ]}
    />
  );
};

export default AddPrivateHubModal;
